import React from 'react';
import { Handle, Position } from 'reactflow';
import { Settings, Database } from 'lucide-react';
import { Workflow } from '../../types/workflow';

interface N8nDAppConfigNodeProps {
  data: {
    workflow: Workflow;
    onEditDAppConfig?: () => void;
  };
}

const N8nDAppConfigNode: React.FC<N8nDAppConfigNodeProps> = ({ data }) => {
  const { workflow, onEditDAppConfig } = data;

  return (
    <div className="group relative">
      {/* n8n-style node container */}
      <div className="bg-n8n-dark-700 border-2 border-n8n-dark-600 rounded-n8n shadow-n8n hover:shadow-n8n-lg transition-all duration-200 w-48 min-h-16 p-3">
        {/* Node header */}
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-n8n-accent-500/20 rounded-full flex items-center justify-center">
              <Database size={16} className="text-n8n-accent-400" />
            </div>
            <div>
              <div className="font-medium text-n8n-dark-200 text-sm">dApp Config</div>
              <div className="text-xs text-n8n-dark-400">Blockchain</div>
            </div>
          </div>
          <div className="opacity-0 group-hover:opacity-100 transition-opacity">
            <button 
              onClick={onEditDAppConfig}
              className="p-1 hover:bg-n8n-dark-600 rounded transition-colors duration-200"
            >
              <Settings size={12} className="text-n8n-dark-300" />
            </button>
          </div>
        </div>

        {/* Node content */}
        <div className="text-xs text-n8n-dark-300 space-y-1">
          <div className="truncate">
            <span className="font-medium">dApp:</span> {workflow.workflow.name || 'Not set'}
          </div>
          <div className="truncate">
            <span className="font-medium">Chain:</span> {typeof workflow.dapp?.targetChainID !== 'undefined' ? workflow.dapp?.targetChainID : (workflow.chain_id ?? '—')}
          </div>
        </div>
      </div>

      {/* n8n-style connection handles */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-2 h-2 bg-n8n-accent-500 border-2 border-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-n8n"
        style={{ left: -6 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        className="w-2 h-2 bg-n8n-accent-500 border-2 border-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-n8n"
        style={{ right: -6 }}
      />
    </div>
  );
};

export default N8nDAppConfigNode;